export const Enroll = () => {
  return (
    <div>
      <h1>Enroll</h1>
    </div>
  );
};
